import React from "react";
import { Link } from "react-router-dom";
import { HourglassMedium } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export default function Pending() {
  return (
    <div className="min-h-screen flex items-center justify-center p-8">
      <div className="max-w-lg text-center fade-up" data-testid="pending-page">
        <img src="/logo.png" alt="Housetag" className="w-16 h-16 mx-auto mb-4 object-contain" />
        <div className="mx-auto w-20 h-20 rounded-full bg-purple-100 flex items-center justify-center mb-6">
          <HourglassMedium size={38} color="#6D28D9" weight="duotone" />
        </div>
        <div className="label-eyebrow">In attesa</div>
        <h1 className="font-display text-4xl font-bold tracking-tight mt-3">
          Il tuo account è in <span className="ht-gradient-text">fase di approvazione</span>
        </h1>
        <p className="text-muted-foreground mt-4 leading-relaxed">
          Controlla la tua casella email (anche nello spam) e clicca sul link di conferma.
          Solo dopo la conferma il nostro team attiverà il tuo account.
        </p>
        <div className="mt-8 flex gap-3 justify-center">
          <Link to="/login">
            <Button variant="outline" data-testid="pending-back-login">Torna al login</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
